import { PropsWithChildren, useContext, useState } from 'react'
import {
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger
} from './ui/popover.tsx'
import { MainContext } from '../context/main.tsx'

export function PopoverTooltip ({ title, description, children }: PropsWithChildren<{
  title: string
  description: string
}>): JSX.Element {
  const { mainRef } = useContext(MainContext)
  const [open, setOpen] = useState(false)
  const handleOpenChange = (value: boolean): void => {
    // Schedule value change in next run loop, because on mobile
    // we get two events when trying to close the popover with the trigger.
    // Scheduling the change in the next run loop, allows both events to resolve before
    // changing the value.
    setTimeout(() => setOpen(value), 0)
  }
  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger openOnHover>{children}
      </PopoverTrigger>
      <PopoverContent align='center' side='top' className='bg-white' container={mainRef}>
        <PopoverHeader>
          <PopoverTitle>{title}</PopoverTitle>
          <PopoverDescription>{description}</PopoverDescription>
        </PopoverHeader>
      </PopoverContent>
    </Popover>
  )
}
